var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"JsonWgs84PolygonField",class:{ error: _vm.error }},[(_vm.value)?_c('GoogleMap',{staticStyle:{"height":"calc(100vh - 200px)","max-height":"500px"},attrs:{"editPolyline":_vm.value.points}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }